<template>
  <div class="page">
    <p class="p1">
      开票信息
      <span class="rt-pos" @click="goBack()"></span>
    </p>
    <div class="div-class">
      <p class="head-p">
        <span style="display: inline-block;width: 60px;text-align: left;">ICCID：</span>
        <span style="margin-left: 8px;">{{receipt.iccid}}</span>
      </p>
    </div>
    <div class="div-class">
      <p>
        <span style="display: inline-block;width: 60px;text-align: right;">发票金额：</span>
        <span style="color: red;font-size: 15px;margin-left: 10px;">{{'¥' +receipt.totalMoney}}</span>
      </p>
    </div>
    <div class="nr-class">
      <div class="div-class">
        <span>抬头类型：</span>
        <span class="tai-class">
          <nut-radio v-model="receipt.titleType" label="1" size="small">企业单位</nut-radio>
          <nut-radio v-model="receipt.titleType" label="2" size="small">个人/事业单位</nut-radio>
        </span>
      </div>
      <div class="div-class">
        <span>发票类型：</span>
        <span class="tai-class">
          <nut-radio v-model="receipt.type" label="1" size="small">电子发票（普通发票）</nut-radio>
          <br>
          <span style="line-height: 30px;"></span>
          <nut-radio v-model="receipt.type" label="2" size="small" v-if="receipt.titleType == '1'" style="margin-left: 64px;">电子发票（增值税专用发票）</nut-radio>
        </span>
      </div>
      <div class="div-class">
        <nut-textinput v-model="receipt.title" label="发票抬头：" placeholder="请选择发票抬头" :clearBtn="false" @click="showAddressOther" onfocus="this.blur()"/>
        <nut-address 
          v-model="showPopupOther" 
          type="exist" 
          existAddressTitle="请选择"
          customAndExistTitle="新增发票信息"
          :existAddress="existAddress"
          @switchModule="switchModule" 
          @onChange="onChange3" 
          @close="close1">
        </nut-address>
      </div>
      <div class="div-class">
        <nut-textinput v-model="receipt.ein" label="公司税号：" placeholder="公司税号" :clearBtn="false"/>
      </div>
      <div class="div-class-tip"  v-if="receipt.type ==1">
        <nut-cell style="background-image:none" >
          <span slot="sub-title" style="line-height: 1.5;"><i style="color:red">温馨提示：</i>发票内容【电信服务*信息服务费】，发票按填写内容开具，请仔细核对，如有其他需求，请联系客服。</span>
        </nut-cell>
      </div>
      <div class="div-class" v-if="receipt.type ==2">
        <nut-textinput v-model="receipt.businessAddress" label="注册地址：" placeholder="注册地址" :clearBtn="false"/>
      </div>
      <div class="div-class" v-if="receipt.type ==2">
        <nut-textinput v-model="receipt.businessPhone" label="注册电话：" placeholder="注册电话" :clearBtn="false"/>
      </div>
      <div class="div-class" v-if="receipt.type ==2">
        <nut-textinput v-model="receipt.bank" label="开户银行：" placeholder="开户银行" :clearBtn="false"/>
      </div>
      <div class="div-class" v-if="receipt.type ==2">
        <nut-textinput v-model="receipt.bankAccount" label="银行账号：" placeholder="银行账号" :clearBtn="false"/>
      </div>
    </div>

    <div class="div-class-tip"  v-if="receipt.type ==2">
        <nut-cell style="background-image:none" >
          <span slot="title" style="line-height: 1.5;font-size: 10px;color:#848484 "><i style="color:red">温馨提示：</i>发票内容【电信服务*信息服务费】，根据规定开具专用发票需提供企业盖章合同，请提交后联系客服处理，谢谢！</span>
        </nut-cell>
    </div>

    <div style="padding-bottom: 85px;">
      <div class="div-class-phone">
        <nut-textinput v-model="receipt.phone" label="收票手机：" placeholder="收票手机" :clearBtn="false" type="tel"/>
      </div>
      <div class="div-class-email">
        <nut-textinput v-model="receipt.email" label="收票邮箱：" placeholder="收票邮箱" :clearBtn="false"/>
      </div>
    </div>
    <div class="footer">
      <nut-button @click="nextStep()">{{'提交申请'}}</nut-button>
    </div>
  </div>
</template>
<script>
import {wx_invoiceUserInvoiceCompany, wx_specialInvoiceSaveInvoiceDetail} from "@/api/api.js";
import { wx_invoiceSaveInvoiceDetail } from "@/api/api.js";
export default {
  data() {
    return {
      receipt:{
        type:"1",
        titleType:"1",
        title:"",
        ein:"",
        businessAddress:"",
        businessPhone:"",
        bank:"",
        bankAccount:"",
        price:"25",
        email:"",
        phone:"",
        area:"",
        address:"",
      },
      option:"请选择发票信息",
      showPopupOther:false,
      existAddress:[],
      fpnr:"信息技术服务费",
    };
  },
  watch:{
    'receipt.titleType'(val){
      this.receipt.type = "1"
    },
    $route: {
      handler() {
        if(this.$route.params.iccid){
          sessionStorage.setItem("invoiceXx.iccid", this.$route.params.iccid);
          sessionStorage.setItem("invoiceXx.orderNums", JSON.stringify(this.$route.params.orderNums));
          sessionStorage.setItem("invoiceXx.code", this.$route.params.code);
          sessionStorage.setItem("invoiceXx.channel", this.$route.params.channel);
          sessionStorage.setItem("invoiceXx.totalMoney", this.$route.params.totalMoney);
        }
        this.receipt.iccid = this.$route.params.iccid || sessionStorage.getItem("invoiceXx.iccid");
        this.receipt.orderNums = this.$route.params.orderNums || JSON.parse(sessionStorage.getItem("invoiceXx.orderNums"));
        this.receipt.code = this.$route.params.code || sessionStorage.getItem("invoiceXx.code");
        this.receipt.channel = this.$route.params.channel || sessionStorage.getItem("invoiceXx.channel");
        this.receipt.totalMoney = this.$route.params.totalMoney || sessionStorage.getItem("invoiceXx.totalMoney");
      },
      immediate: true
    },
  },
  computed: {},
  methods: {
    // 后退到上一页
    goBack(){
      this.$router.go(-1);
    },
    showAddressOther(){
      this.showPopupOther = true;
      let params ={
        code:localStorage.getItem("code"),
        channel:localStorage.getItem("channel")
      }
      wx_invoiceUserInvoiceCompany(params).then(res=>{
        if(res.data.code == 200){
          this.existAddress = res.data.data;
          this.existAddress.map(item=>{
            item.addressDetail = item.title;
            item.cityName = "";
            item.countyName = "";
            item.provinceName = "";
            item.townName = "";
            item.selectedAddress = false;
          })       
        }else{
          this.$toast.fail(res.data.message);
        }
      });
    },
    close1(val){
      this.receipt.title = val.data.addressDetail;
      this.receipt.ein = val.data.ein;
      this.receipt.companyId = val.data.id;
      this.receipt.businessAddress = val.data.businessAddress;
      this.receipt.businessPhone = val.data.businessPhone;
      this.receipt.bank = val.data.bank;
      this.receipt.bankAccount = val.data.bankAccount;
    },
    onChange3(cal){
      console.log('change2',cal)
    },
    switchModule(){
      this.$router.push({
        path: "/invoiceManage/invoiceDetails",
      });
    },
    nextStep(){
      if(this.receipt.type == "1"){
        let params ={
          ...this.receipt
        }
        params.kdmoney = "";
        wx_invoiceSaveInvoiceDetail(params).then(res=>{
          if(res.data.code == 200){
            this.$toast.success('申请成功！');
            setTimeout(() => {
              this.$router.push({
                name: "invoiceOrder",
              });
            },800)
          }else{
            this.$toast.fail(res.data.message);
          }
        })
      }else{
        let params ={
          ...this.receipt
        }
        wx_specialInvoiceSaveInvoiceDetail(params).then(res=>{
          if(res.data.code == 200){
            this.$toast.success('申请成功！');
            setTimeout(() => {
              this.$router.push({
                name: "invoiceOrder",
              });
            },800)
          }else{
            this.$toast.fail(res.data.message);
          }
        })
      }
    },
  },
  created() {
    this.code = localStorage.getItem("code")
  },
  mounted() {
    window.document.title = "开票信息";
  },
};
</script>
<style scoped lang="less">
  .page{
    .p1{
      text-align: center;
      height: 40px;
      line-height: 40px;
      background: #F94040;
      color: #fff;
      font-size: 18px;
      position: relative;
      .rt-pos{
        position: absolute;
        left: 20px;
        top:14px;
        width: 12px;
        height: 12px;
        border-top: 2px solid gainsboro;
        border-left: 2px solid gainsboro;
        transform: rotate(-45deg);
      }
    }
    .div-class{
      padding: 0px 20px;
      margin: 20px 0;
    }
    .div-class-tip{
      padding: 0px 10px;
      margin: 20px 0;
    }
    .div-class-phone{
      padding: 0px 20px;
      margin: 20px 0;
    }
    .div-class-email{
      padding: 0px 20px;
      margin: 20px 0px;
    }
    .div-clas-je{
      margin: 20px 0 -10px 0;
    }
    .fpnr-class{
      /deep/ .nut-textinput-disabled input{
        border: 1px solid #DDDFE6;
        background: none;
        color: red;
        font-size: 15px;
        font-weight: bold;
      } 
    }
    .head-p{
      font-size: 13px;
    }
    .tai-class{
      margin-left: 4px;
      position: relative;
      top:-2px
    }
    .kong{
      width: 100%;
      height: 20px;
      background: #ededed;
    }
    .footer{
      background: #F8F8F8;
      padding: 15px 0;
      display: flex;
      justify-content: center;
      position: fixed;
      bottom: 0;
      width: 100%;
      z-index: 23;
      button{
        border-radius: 10px;
        width: 52%;
        font-size: 14px;
        height: 45px;
        line-height: 45px;
        border: 1px solid #F94040 !important;
      }
    }
  }
</style>

